"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
var option_1 = require("./option");
Object.defineProperty(exports, "Option", { enumerable: true, get: function () { return __importDefault(option_1).default; } });
//# sourceMappingURL=index.js.map